module.exports = __webpack_public_path__ + "img/RBS04_4_loading.98915733.jpg";